<template>
	<div class="video-coursesPage">
		<!-- banner -->
		<div class="banner-box">
			<div class="banner-font">
				<div class="banner-font-left">
					<h2 class="title1">—— 中投顾问 · 城市发展大讲堂 ——</h2>
					<h1 class="title2 my-3"><span class="yellow-font">区域经济高质量发展视频课：</span><span
							class="white-font">城市竞争战略</span></h1>
					<p class="banner-p1">以完全市场化的视角，剖析城市经济和产业发展的逻辑，</p>
					<p class="banner-p2">为区域经济发展、城市产业战略提供全新的发展思路。</p>
				</div>
				<div class="header-sam">
					<img src="../../assets/Sam.png" alt="" class="fl">
					<div class="fr profile">
						<p><b>主讲人：扈志亮</b></p>
						<p>中投顾问创始人、董事长</p>
						<p>中投产业研究院院长</p>
						<p>产业大脑产品经理</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 主体内容 -->
		<div class="con center-page ">
			<h3 class="floor_title">课程框架</h3>
			<div class="floatAfter courses-list flexcss-list">
				<ul class="widht70 meun-list">
					<li @click="sroucfun(1)">第一讲 城市的<b>商业模式</b>：平台经济</li>
					<li @click="sroucfun(2)">第二讲 城市的<b>经营逻辑</b>：与企业经营逻辑相同</li>
					<li @click="sroucfun(3)">第三讲 城市的<b>业务战略</b>：做好主导产业、抓住新兴产业</li>
					<li @click="sroucfun(4)">第四讲 城市的<b>增长战略</b>：一个经典的战略配方</li>
					<li @click="sroucfun(5)">第五讲 城市的<b>创新战略</b>：学会管理失败，善败者不亡</li>
					<li @click="sroucfun(6)">第六讲 城市的<b>产品战略</b>：用什么吸引企业和人才</li>
					<li @click="sroucfun(7)">第七讲 城市的<b>营销战略</b>：把好故事传播出去</li>
					<li @click="sroucfun(8)">第八讲 城市的<b>销售战略</b>：招商引资怎样做得专业</li>
					<li @click="sroucfun(9)">第九讲 城市的<b>战略灵魂</b>：时代呼唤战略家型官员</li>
				</ul>
				<div class="code-phone width30"><img src="../../assets/coursesPhoneCode.jpg" />
					<p>微信扫码，手机上看</p>
				</div>
			</div>

		</div>
		<div class="center-page mb-3">
			<h3 class="floor_title">课程内容</h3>
		</div>
		<div class="floor-box" v-for="(list, i) in coursesList" :key="i" :class="i % 2 != 0 ? 'bule-bg' : ''">
			<div class=" courses-list center-page ">
				<h2 class="courses-pro-title">{{ list.title }}</h2>
				<div class="floatAfter courses-videoList" v-for="(item, im) in list.children" :key="im">
					<ul class="widht43">
						<li :key="i" v-for="(item1, i) in item.subsetList" :class="item1.isBlod ? 'font-weight' : 'grayfont'">
							{{ item1.smTitle }}</li>
					</ul>
					<div class="widht57 play-btn-box" @click="palybtn(item)">
						<video ref="myPlayer" :src="item.videoUrl" class="courses-video" :poster="item.posterImg"></video>
						<div class="play-btn"></div>
					</div>
				</div>

			</div>
		</div>
		<el-dialog title="" :top="'10vh'" width="1100px" :visible.sync="open" @close="closeFun" class="dialog">
			<video id="myVideo" controls ref="myPlayer1" class="courses-video1" autoplay :src="curVedioUrl"
				:poster="curVedioImg"></video>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'video-courses',
	data() {
		return {
			title: "《城市竞争战略课》",
			open: false,
			curVedioUrl: 'https://dpv.videocc.net/44796099a4/b/44796099a463d9c87e1bf9c8f903b73b_2.mp4?pid=1708488758828X1940730',
			curVedioImg: 'https://img.videocc.net/uimage/4/44796099a4/b/44796099a463d9c87e1bf9c8f903b73b_0_b.jpg',
			coursesList: [{
				title: '导论：用经营企业思路来经营城市',
				children: [{
					subsetList: [{ smTitle: "城市本质上是一个平台", isBlod: true, }, { smTitle: "城市战略往大看像国家、往小看像企业", isBlod: true, }, { smTitle: "城市也要讲经营逻辑（平台经济）", isBlod: true, }, { smTitle: "企业的成败看企业家，城市的兴衰看主政官员", isBlod: true, }],
					videoUrl: 'https://dpv.videocc.net/44796099a4/b/44796099a463d9c87e1bf9c8f903b73b_2.mp4?pid=1708488758828X1940730',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/b/44796099a463d9c87e1bf9c8f903b73b_0_b.jpg'
				},
				],
			},
			{
				title: '第一讲 城市的商业模式',
				children: [{
					subsetList: [{ smTitle: "城市本质上是一个平台", isBlod: true, }, { smTitle: "平台是一种基础设施", isBlod: true, }, { smTitle: "平台具有网络效应", isBlod: true, }, { smTitle: "平台具有规模效应", isBlod: true, }, { smTitle: "平台可以赢家通吃", isBlod: true, }, { smTitle: "平台的运营者，要敬畏用户", isBlod: true, }],
					videoUrl: 'https://dpv.videocc.net/44796099a4/a/44796099a44f8a6ab4a478746ba509fa_2.mp4?pid=1708569287484X1357816',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/a/44796099a44f8a6ab4a478746ba509fa_1_b.jpg'
				},
				],
			},
			{
				title: '第二讲 城市的经营逻辑与企业类似',
				children: [{
					subsetList: [{ smTitle: "城市是一个经济体", isBlod: true, }, { smTitle: "都有自己的用户：企业、人才、居民；", isBlod: true, }, { smTitle: "都有自己的产品：投资环境；", isBlod: true, }, { smTitle: "都要做好营销：城市品牌、城市营销；", isBlod: true, }, { smTitle: "都要做好服务：软环境、服务能力；", isBlod: true, }, { smTitle: "都要面临竞争：招商竞争跟企业间竞争一样卷。", isBlod: true, }],
					videoUrl: 'https://dpv.videocc.net/44796099a4/c/44796099a44837f1b5d7d9a28aeec5ac_2.mp4?pid=1708569646102X1486370',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/c/44796099a44837f1b5d7d9a28aeec5ac_5_b.jpg'
				},
				],
			},
			{
				title: '第三讲 城市的业务战略',
				children: [{
					subsetList: [{ smTitle: "专业化与多元化之争", isBlod: true, }, { smTitle: "主导产业如何持续做大，让长板更长", isBlod: false, }, { smTitle: "新兴产业怎么有效培育，把握新机会", isBlod: false, }, { smTitle: "不同产业之间要协同", isBlod: false, }, { smTitle: "注意产业层次的布局", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/5/44796099a4e3f8115b5010bf6682e0e5_2.mp4?pid=1708569765857X1787665',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/5/44796099a4e3f8115b5010bf6682e0e5_1_b.jpg'
				},
				{
					subsetList: [{ smTitle: "专业化与多元化之争", isBlod: false, }, { smTitle: "主导产业如何持续做大，让长板更长", isBlod: true, }, { smTitle: "新兴产业怎么有效培育，把握新机会", isBlod: false, }, { smTitle: "不同产业之间要协同", isBlod: false, }, { smTitle: "注意产业层次的布局", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/f/44796099a421860cc08b019c74ace38f_2.mp4?pid=1708569777437X1213520',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/f/44796099a421860cc08b019c74ace38f_0_b.jpg'
				},
				{
					subsetList: [{ smTitle: "专业化与多元化之争", isBlod: false, }, { smTitle: "主导产业如何持续做大，让长板更长", isBlod: false, }, { smTitle: "新兴产业怎么有效培育，把握新机会", isBlod: true, }, { smTitle: "不同产业之间要协同", isBlod: true, }, { smTitle: "注意产业层次的布局", isBlod: true, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/5/44796099a45a6ea492676220b96babd5_2.mp4?pid=1708569876335X1988829',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/5/44796099a45a6ea492676220b96babd5_3_b.jpg'
				},
				],
			},
			{
				title: '第四讲 城市的增长战略',
				children: [{
					subsetList: [{ smTitle: "可持续增长的问题", isBlod: true, }, { smTitle: "来自麦肯锡的战略配方", isBlod: true, }, { smTitle: "企业战略的框架", isBlod: false, }, { smTitle: "城市战略的借鉴", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/b/44796099a4d84d0812c70e5c3af3f0db_2.mp4?pid=1708570083083X1567238',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/b/44796099a4d84d0812c70e5c3af3f0db_2_b.jpg'
				},
				{
					subsetList: [{ smTitle: "可持续增长的问题", isBlod: false, }, { smTitle: "来自麦肯锡的战略配方", isBlod: false, }, { smTitle: "企业战略的框架", isBlod: true, }, { smTitle: "城市战略的借鉴", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/d/44796099a4ef8951d286ce3d5718e54d_2.mp4?pid=1708570208436X1109561',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/d/44796099a4ef8951d286ce3d5718e54d_1_b.jpg'
				},
				{
					subsetList: [{ smTitle: "可持续增长的问题", isBlod: false, }, { smTitle: "来自麦肯锡的战略配方", isBlod: false, }, { smTitle: "企业战略的框架", isBlod: false, }, { smTitle: "城市战略的借鉴", isBlod: true, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/6/44796099a49a9d309b38750e1c2dda26_2.mp4?pid=1708570251834X1111177',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/6/44796099a49a9d309b38750e1c2dda26_0_b.jpg'
				},
				],
			},
			{
				title: '第五讲 城市的创新战略',
				children: [{
					subsetList: [{ smTitle: "理解创新的本质", isBlod: true, }, { smTitle: "管理失败，善败者不亡", isBlod: false, }, { smTitle: "几个有效的创新策略", isBlod: false, }, { smTitle: "领军人才是原始创新的关键", isBlod: false, }, { smTitle: "创新生态：技术的堆叠效应", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/8/44796099a400cb5610e6126fe5c32918_2.mp4?pid=1708570495391X1467337',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/8/44796099a400cb5610e6126fe5c32918_2_b.jpg'
				},
				{
					subsetList: [{ smTitle: "理解创新的本质", isBlod: false, }, { smTitle: "管理失败，善败者不亡", isBlod: true, }, { smTitle: "几个有效的创新策略", isBlod: false, }, { smTitle: "领军人才是原始创新的关键", isBlod: false, }, { smTitle: "创新生态：技术的堆叠效应", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/9/44796099a414973343f21bcbc1789ba9_2.mp4?pid=1708570511177X1165290',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/9/44796099a414973343f21bcbc1789ba9_0_b.jpg'
				},
				{
					subsetList: [{ smTitle: "理解创新的本质", isBlod: false, }, { smTitle: "管理失败，善败者不亡", isBlod: false, }, { smTitle: "几个有效的创新策略", isBlod: true, }, { smTitle: "领军人才是原始创新的关键", isBlod: false, }, { smTitle: "创新生态：技术的堆叠效应", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/9/44796099a4c5eb6453ec10692bfe9c09_2.mp4?pid=1708570519634X1105756',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/9/44796099a4c5eb6453ec10692bfe9c09_0_b.jpg'
				},
				{
					subsetList: [{ smTitle: "理解创新的本质", isBlod: false, }, { smTitle: "管理失败，善败者不亡", isBlod: false, }, { smTitle: "几个有效的创新策略", isBlod: false, }, { smTitle: "领军人才是原始创新的关键", isBlod: true, }, { smTitle: "创新生态：技术的堆叠效应", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/a/44796099a4e7ea91e84f339d0c61c58a_2.mp4?pid=1708570529032X1323992',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/a/44796099a4e7ea91e84f339d0c61c58a_0_b.jpg'
				},
				{
					subsetList: [{ smTitle: "理解创新的本质", isBlod: false, }, { smTitle: "管理失败，善败者不亡", isBlod: false, }, { smTitle: "几个有效的创新策略", isBlod: false, }, { smTitle: "领军人才是原始创新的关键", isBlod: false, }, { smTitle: "创新生态：技术的堆叠效应", isBlod: true, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/3/44796099a4fa16ae08eea247a7188b63_2.mp4?pid=1708570539649X1570586',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/3/44796099a4fa16ae08eea247a7188b63_0_b.jpg'
				},
				],
			},
			{
				title: '第六讲 城市的产品战略',
				children: [{
					subsetList: [{ smTitle: "产品，就是投资环境", isBlod: true, }, { smTitle: "硬件：基础设施", isBlod: true, }, { smTitle: "软件：营商环境", isBlod: false, }, { smTitle: "服务体系：用户界面", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/3/44796099a44bbfb1b25d6fa8ea5b1be3_2.mp4?pid=1708570680680X1597461',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/3/44796099a44bbfb1b25d6fa8ea5b1be3_1_b.jpg'
				},
				{
					subsetList: [{ smTitle: "产品，就是投资环境", isBlod: false, }, { smTitle: "硬件：基础设施", isBlod: false, }, { smTitle: "软件：营商环境", isBlod: true, }, { smTitle: "服务体系：用户界面", isBlod: true, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/8/44796099a487a9fe1a9759babd8c6628_2.mp4?pid=1708570694838X1613960',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/8/44796099a487a9fe1a9759babd8c6628_0_b.jpg'
				},
				],
			},
			{
				title: '第七讲 城市的营销战略',
				children: [{
					subsetList: [{ smTitle: "营销对象：目标用户群", isBlod: true, }, { smTitle: "营销渠道：新渠道层出不穷", isBlod: false, }, { smTitle: "营销方式：要不断创新", isBlod: false, }, { smTitle: "项目包装：产品具体化", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/f/44796099a4772cec046526c34f4d206f_2.mp4?pid=1708570876500X1673068',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/f/44796099a4772cec046526c34f4d206f_2_b.jpg'
				},
				{
					subsetList: [{ smTitle: "营销对象：目标用户群", isBlod: false, }, { smTitle: "营销渠道：新渠道层出不穷", isBlod: true, }, { smTitle: "营销方式：要不断创新", isBlod: false, }, { smTitle: "项目包装：产品具体化", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/1/44796099a44f37c03c0abb62c97c1821_2.mp4?pid=1708570893110X1709583',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/1/44796099a44f37c03c0abb62c97c1821_2_b.jpg'
				},
				{
					subsetList: [{ smTitle: "营销对象：目标用户群", isBlod: false, }, { smTitle: "营销渠道：新渠道层出不穷", isBlod: false, }, { smTitle: "营销方式：要不断创新", isBlod: true, }, { smTitle: "项目包装：产品具体化", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/a/44796099a4951fc20647bb761623e0ca_2.mp4?pid=1708570904833X1697179',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/a/44796099a4951fc20647bb761623e0ca_1_b.jpg'
				},
				{
					subsetList: [{ smTitle: "营销对象：目标用户群", isBlod: false, }, { smTitle: "营销渠道：新渠道层出不穷", isBlod: false, }, { smTitle: "营销方式：要不断创新", isBlod: false, }, { smTitle: "项目包装：产品具体化", isBlod: true, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/9/44796099a4f0465584f2dfc4c04c77e9_2.mp4?pid=1708570913934X1839316',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/9/44796099a4f0465584f2dfc4c04c77e9_1_b.jpg'
				},
				],
			},
			{
				title: '第八讲 城市的销售战略',
				children: [{
					subsetList: [{ smTitle: "招商引资就是销售城市的投资环境", isBlod: true, }, { smTitle: "招商引资的市场化理念", isBlod: true, }, { smTitle: "招商是一个系统工程", isBlod: true, }, { smTitle: "产业链招商的工作要点", isBlod: false, }, { smTitle: "资本招商的工作要点", isBlod: false, }, { smTitle: "招商的数字化趋势", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/8/44796099a4ab67c456089ea96a6add48_2.mp4?pid=1708571135561X1881524',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/8/44796099a4ab67c456089ea96a6add48_1_b.jpg'
				},
				{
					subsetList: [{ smTitle: "招商引资就是销售城市的投资环境", isBlod: false, }, { smTitle: "招商引资的市场化理念", isBlod: false, }, { smTitle: "招商是一个系统工程", isBlod: false, }, { smTitle: "产业链招商的工作要点", isBlod: true, }, { smTitle: "资本招商的工作要点", isBlod: false, }, { smTitle: "招商的数字化趋势", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/8/44796099a4df7c646133c2651a083588_2.mp4?pid=1708571146516X1376886',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/8/44796099a4df7c646133c2651a083588_1_b.jpg'
				},
				{
					subsetList: [{ smTitle: "招商引资就是销售城市的投资环境", isBlod: false, }, { smTitle: "招商引资的市场化理念", isBlod: false, }, { smTitle: "招商是一个系统工程", isBlod: false, }, { smTitle: "产业链招商的工作要点", isBlod: false, }, { smTitle: "资本招商的工作要点", isBlod: true, }, { smTitle: "招商的数字化趋势", isBlod: false, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/2/44796099a43ff1610b2beff20dc6b6c2_2.mp4?pid=1708571155739X1671745',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/2/44796099a43ff1610b2beff20dc6b6c2_2_b.jpg'
				},
				{
					subsetList: [{ smTitle: "招商引资就是销售城市的投资环境", isBlod: false, }, { smTitle: "招商引资的市场化理念", isBlod: false, }, { smTitle: "招商是一个系统工程", isBlod: false, }, { smTitle: "产业链招商的工作要点", isBlod: false, }, { smTitle: "资本招商的工作要点", isBlod: false, }, { smTitle: "招商的数字化趋势", isBlod: true, },],
					videoUrl: 'https://dpv.videocc.net/44796099a4/3/44796099a471cc35036c1e76c28ea343_2.mp4?pid=1708571165474X1711263',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/3/44796099a471cc35036c1e76c28ea343_3_b.jpg'
				},
				],
			},
			{
				title: '第九讲 城市的战略灵魂',
				children: [{
					subsetList: [{ smTitle: "战略家型官员就是城市的CEO", isBlod: true, }, { smTitle: "江上舟：上海半导体产业的孵化者", isBlod: false, }, { smTitle: "黄奇帆：让一个内地山城变为西部中心城市", isBlod: false, }, { smTitle: "优秀的企业家、科学家和官员，都是时代的英雄", isBlod: false, }, { smTitle: "补充：展望未来", isBlod: false, }],
					videoUrl: 'https://dpv.videocc.net/44796099a4/9/44796099a4a88f9331f41b548e6b6179_2.mp4?pid=1708571415985X1755034',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/9/44796099a4a88f9331f41b548e6b6179_2_b.jpg'
				},
				{
					subsetList: [{ smTitle: "战略家型官员就是城市的CEO", isBlod: false, }, { smTitle: "江上舟：上海半导体产业的孵化者", isBlod: true, }, { smTitle: "黄奇帆：让一个内地山城变为西部中心城市", isBlod: false, }, { smTitle: "优秀的企业家、科学家和官员，都是时代的英雄", isBlod: false, }, { smTitle: "补充：展望未来", isBlod: false, }],
					videoUrl: 'https://dpv.videocc.net/44796099a4/c/44796099a4f050ce8f7c5af6cb2990ac_2.mp4?pid=1708571432295X1621070',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/c/44796099a4f050ce8f7c5af6cb2990ac_1_b.jpg'
				},
				{
					subsetList: [{ smTitle: "战略家型官员就是城市的CEO", isBlod: false, }, { smTitle: "江上舟：上海半导体产业的孵化者", isBlod: false, }, { smTitle: "黄奇帆：让一个内地山城变为西部中心城市", isBlod: true, }, { smTitle: "优秀的企业家、科学家和官员，都是时代的英雄", isBlod: false, }, { smTitle: "补充：展望未来", isBlod: false, }],
					videoUrl: 'https://dpv.videocc.net/44796099a4/2/44796099a466a80b3a097bf7d7d49802_2.mp4?pid=1708571445553X1214222',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/2/44796099a466a80b3a097bf7d7d49802_1_b.jpg'
				},
				{
					subsetList: [{ smTitle: "战略家型官员就是城市的CEO", isBlod: false, }, { smTitle: "江上舟：上海半导体产业的孵化者", isBlod: false, }, { smTitle: "黄奇帆：让一个内地山城变为西部中心城市", isBlod: false, }, { smTitle: "优秀的企业家、科学家和官员，都是时代的英雄", isBlod: true, }, { smTitle: "补充：展望未来", isBlod: false, }],
					videoUrl: 'https://dpv.videocc.net/44796099a4/7/44796099a4a9b5ab513b08852a4fb057_2.mp4?pid=1708571461224X1667199',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/7/44796099a4a9b5ab513b08852a4fb057_1_b.jpg'
				},
				{
					subsetList: [{ smTitle: "战略家型官员就是城市的CEO", isBlod: false, }, { smTitle: "江上舟：上海半导体产业的孵化者", isBlod: false, }, { smTitle: "黄奇帆：让一个内地山城变为西部中心城市", isBlod: false, }, { smTitle: "优秀的企业家、科学家和官员，都是时代的英雄", isBlod: false, }, { smTitle: "补充：展望未来", isBlod: true, }],
					videoUrl: 'https://dpv.videocc.net/44796099a4/6/44796099a4c1a3a4d5cdd008ac79bda6_2.mp4?pid=1708571473178X1698502',
					posterImg: 'https://img.videocc.net/uimage/4/44796099a4/6/44796099a4c1a3a4d5cdd008ac79bda6_0_b.jpg'
				},
				],
			},
			],
		};
	},
	created() { },
	mounted() {
		document.title = '中投顾问-城市发展大讲堂:城市竞争战略课';
	},
	methods: {
		sroucfun(i) {
			var layers = document.querySelectorAll(".floor-box")
			var scrollTop = document.documentElement.scrollTop
			var offsetTop = layers[i].offsetTop
			if (scrollTop > offsetTop) {
				// 滚动条向上移动
				var timer = setInterval(function () {
					if (scrollTop > offsetTop) {
						scrollTop -= 240
						if (scrollTop - offsetTop < 240) {
							// 如果最后一洞的距离小于40时，直接设置偏移量为0
							window.scrollTo(85, offsetTop)
						} else {
							window.scrollTo(85, scrollTop)
						}
					} else {
						clearInterval(timer)
					}
				}, 5000)
			} else {
				// 滚动条向下移动
				// scrollTop <= offsetTop
				var timer = setInterval(function () {
					if (scrollTop < offsetTop) {
						scrollTop += 240
						if (offsetTop - scrollTop < 240) {
							window.scrollTo(85, offsetTop)
						} else {
							window.scrollTo(85, scrollTop)
						}
					} else {
						clearInterval(timer)
					}
				}, 10);


			}
		},
		palybtn(list) {
			this.open = true;
			console.log(list)
			this.$nextTick(() => {
				this.curVedioUrl = list.videoUrl;
				this.curVedioImg = list.posterImg;
				var video = document.getElementById("myVideo");
				// var palyer = this.$refs.myPlayer1;
				console.log(video);
				if (video.paused) {
					video.play(); // 开始播放视频
				} else {
					video.pause(); // 暂停视频播放
				}
			})

		},
		closeFun() {
			this.open = false;
			var video = document.getElementById("myVideo");
			video.pause();
		}
	}
}
</script>

<style>
.center-page {
	width: 50%;
	margin: 0 auto;
	min-width: 1000px;
}

.font-weight {
	font-weight: bold;
	font-size: 18px;
}

.width70 {
	width: 70%;
}

.width30 {
	width: 30%;
}

.widht50 {
	width: 50%;
}

.widht43 {
	width: 43%;
}

.width57 {
	width: 57%;
}

.courses-videoList {
	width: 1000px;
	margin-left: 76px;
	vertical-align: middle;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.flexcss-list {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.meun-list {
	cursor: pointer;
}

.code-phone {
	text-align: center;
}

.code-phone img {
	width: 120px;
	height: 120px;
}

.code-phone p {
	color: #ffa218;
	margin-top: 10px;
}

.bule-bg {
	background-color: #f2f6ff;
}

.meun-list li:hover {
	color: #276b87;
}

.play-btn-box {
	position: relative;

}

.play-btn-box:hover .play-btn {
	background-color: rgb(0, 0, 0, .5);
	background-size: 100px 100px;
}

.play-btn {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 97%;
	background-color: rgb(0, 0, 0, .3);
	border-radius: 12px;
	background-image: url('../../assets/imgplay2.png');
	background-repeat: no-repeat;
	background-size: 80px 80px;
	background-position: 170px 75px;
	cursor: pointer;
	transition: all .3s;
}

.mb-3 {
	margin-bottom: 30px;
}

.grayfont {
	color: #9b9b9b;
}

.floatAfter::after {
	display: block;
	clear: both;
	content: "";
}

.floatAfter {
	padding-bottom: 70px;
}

.border-b {
	border-bottom: 2px solid #cee0ff;
}

.video-coursesPage {
	background-color: #fff;
}

.video-coursesPage li {
	list-style: disc;
	margin-left: 20px;
}

.banner-box {
	width: 100%;
	height: 544px;
	background: url('../../assets/courseBanner.jpg') no-repeat;
	background-size: 100% 100%;
}

.banner-font {
	width: 68%;
	min-width: 1440px;
	height: 100%;
	margin: 0 auto;
	color: #ffde28;
	letter-spacing: 2px;
	position: relative;
}

.banner-font-left {
	margin-left: 60px;
}

.title1 {
	padding-top: 80px;
	padding-left: 30px;
	letter-spacing: 1px;
	font-size: 30px;
	font-weight: normal;
}

.title2 {
	font-size: 36px;
	line-height: 150px;
}

.title2 .white-font {
	color: #fff;
	font-size: 46px;
	text-shadow: 1px 1px 4px rgb(0 0 0 / 80%);
}

.my-3 {
	margin-top: 30px;
	margin-bottom: 30px;
}

.banner-p1 {
	margin-top: 25px;
}

.banner-p1,
.banner-p2 {
	font-size: 24px;
	line-height: 50px;
}

.header-sam {
	position: absolute;
	right: 0;
	bottom: 0;
}

.header-sam img {
	width: 360px;
	height: 480px;
}

.header-sam .profile {
	color: #fff;
	margin-top: 30%;
	text-align: center;
	line-height: 32px;
}

.header-sam .profile b {
	font-size: 18px;
}

.floor_title {
	font-size: 30px;
	text-align: center;
	position: relative;
	height: 78px;
	line-height: 78px;
	margin-top: 40px;
	margin-bottom: 20px;
	color: #47558d;
}

.floor_title:before {
	content: "";
	width: 118px;
	height: 8px;
	background: #f8b551;
	-webkit-border-radius: 8px;
	-moz-border-radius: 8px;
	border-radius: 8px;
	position: absolute;
	bottom: 0;
}

.courses-list {
	/* padding-bottom: 40px; */
}

.courses-list li {
	line-height: 48px;
	letter-spacing: 1px;
}

.courses-video {
	width: 420px;
	border: 4px solid #000;
	border-radius: 12px;
	box-sizing: border-box;
}

.courses-pro-title {
	color: #276b87;
	line-height: 68px;
	margin-bottom: 10px;
	padding-top: 50px;
}

.dialog {
	text-align: center;
}

.courses-video1 {
	width: 1000px;
}</style>